import { create } from 'zustand'

// Lets a detail page publish a human title (e.g. the lead's name) so the
// breadcrumb shows it instead of the raw UUID from the URL.
interface BreadcrumbState {
  title: string | null
  setTitle: (title: string | null) => void
}

export const useBreadcrumbStore = create<BreadcrumbState>((set) => ({
  title: null,
  setTitle: (title) => set({ title }),
}))
